import Axios from 'axios'
const _external_axios = Axios.create({withCredentials: true})
_external_axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

export default _external_axios
